var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CContainer',{staticClass:"tw-px-1 md:tw-px-4",class:{
    '!tw-px-4': _vm.isMobile,
    'tw-censor': _vm.pageIsExplicitAndRequiresConsent
  }},[(_vm.breadcrumbs && !_vm.isDealerSite)?_c('CBreadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs,"nuxt-links":""}}):_vm._e(),_vm._v(" "),_c('ViewWrapper'),_vm._v(" "),(_vm.pageIsExplicitAndRequiresConsent)?_c('ConsentPrompt'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }